export default __webpack_public_path__ + "static/media/H1003.6.86624d0c.mp3";